export interface CriterioConfig {
  id: string;
  nome: string;
  descricao?: string;
  grupo: string;
  tipo: "boolean" | "faixa" | "quantidade";
  valor_adicional_pct: number;
  valor_adicional_fixo: number;
  ativo: boolean;
  ordem: number;
}

export interface PlanoConfig {
  id: string;
  nome: string;
  descricao?: string;
  multiplicador: number;
  faturamento_min: number;
  faturamento_max?: number | null;
  cor: string;
  destaque: boolean;
  ativo: boolean;
  ordem: number;
}

export const DEFAULT_CRITERIOS: CriterioConfig[] = [
  // Grupo Pessoal / Trabalhista
  {
    id: "crit-pro-labore",
    nome: "Pró-Labore Adicional",
    descricao: "Cálculo e emissão de guias para múltiplos sócios",
    grupo: "Pessoal",
    tipo: "quantidade",
    valor_adicional_pct: 0,
    valor_adicional_fixo: 50,
    ativo: true,
    ordem: 1,
  },
  {
    id: "crit-ponto-eletronico",
    nome: "Tratamento de Ponto Eletrônico",
    descricao: "Gestão e apuração de espelho de ponto digital",
    grupo: "Pessoal",
    tipo: "boolean",
    valor_adicional_pct: 5,
    valor_adicional_fixo: 100,
    ativo: true,
    ordem: 2,
  },
  {
    id: "crit-estagiarios",
    nome: "Gestão de Estagiários e Aprendizes",
    descricao: "Contratos e conformidade de estágio",
    grupo: "Pessoal",
    tipo: "quantidade",
    valor_adicional_pct: 0,
    valor_adicional_fixo: 40,
    ativo: true,
    ordem: 3,
  },
  {
    id: "crit-beneficios",
    nome: "Gestão de Benefícios (VT/VR/Plano de Saúde)",
    descricao: "Compra e rateio de benefícios em folha",
    grupo: "Pessoal",
    tipo: "boolean",
    valor_adicional_pct: 3,
    valor_adicional_fixo: 80,
    ativo: true,
    ordem: 4,
  },

  // Grupo Fiscal / Tributário
  {
    id: "crit-icms-st",
    nome: "Apuração de ICMS-ST",
    descricao: "Substituição tributária e conferência de MVA",
    grupo: "Fiscal",
    tipo: "boolean",
    valor_adicional_pct: 10,
    valor_adicional_fixo: 200,
    ativo: true,
    ordem: 5,
  },
  {
    id: "crit-difal",
    nome: "Cálculo de DIFAL Interestadual",
    descricao: "Diferencial de alíquota para consumidor final ou revenda",
    grupo: "Fiscal",
    tipo: "boolean",
    valor_adicional_pct: 8,
    valor_adicional_fixo: 150,
    ativo: true,
    ordem: 6,
  },
  {
    id: "crit-pis-cofins",
    nome: "PIS/COFINS Não Cumulativo (Lucro Real)",
    descricao: "Apuração detalhada de créditos e débitos",
    grupo: "Fiscal",
    tipo: "boolean",
    valor_adicional_pct: 15,
    valor_adicional_fixo: 350,
    ativo: true,
    ordem: 7,
  },
  {
    id: "crit-retencoes-fonte",
    nome: "Apuração de Retenções na Fonte (IRRF/CSRF/INSS)",
    descricao: "Controle de notas de serviços tomados com retenção",
    grupo: "Fiscal",
    tipo: "boolean",
    valor_adicional_pct: 5,
    valor_adicional_fixo: 100,
    ativo: true,
    ordem: 8,
  },
  {
    id: "crit-importacao",
    nome: "Operações de Importação / Exportação",
    descricao: "Desembaraço aduaneiro e emissão de notas de entrada/saída",
    grupo: "Fiscal",
    tipo: "boolean",
    valor_adicional_pct: 12,
    valor_adicional_fixo: 250,
    ativo: true,
    ordem: 9,
  },

  // Grupo Contábil
  {
    id: "crit-contas-bancarias",
    nome: "Múltiplas Contas Bancárias",
    descricao: "Conciliação bancária de mais de 2 contas correntes",
    grupo: "Contábil",
    tipo: "quantidade",
    valor_adicional_pct: 0,
    valor_adicional_fixo: 75,
    ativo: true,
    ordem: 10,
  },
  {
    id: "crit-centros-custo",
    nome: "Contabilidade por Centro de Custos",
    descricao: "Plano de contas gerencial segmentado por unidade de negócio",
    grupo: "Contábil",
    tipo: "boolean",
    valor_adicional_pct: 10,
    valor_adicional_fixo: 180,
    ativo: true,
    ordem: 11,
  },
  {
    id: "crit-estoque-permanente",
    nome: "Controle de Estoque Permanente (PEPS/Custo Médio)",
    descricao: "Inventário periódico e apuração de CMV",
    grupo: "Contábil",
    tipo: "boolean",
    valor_adicional_pct: 15,
    valor_adicional_fixo: 300,
    ativo: true,
    ordem: 12,
  },
  {
    id: "crit-ativo-imobilizado",
    nome: "Controle Patrimonial de Ativo Imobilizado",
    descricao: "Depreciação mensal e controle de plaquetas",
    grupo: "Contábil",
    tipo: "boolean",
    valor_adicional_pct: 5,
    valor_adicional_fixo: 120,
    ativo: true,
    ordem: 13,
  },

  // Grupo Tecnologia & Integrações
  {
    id: "crit-integracao-erp",
    nome: "Integração via API / ERP de Gestão",
    descricao:
      "Importação automatizada de extratos e faturamento (ex: Omie, ContaAzul, Bling)",
    grupo: "Tecnologia",
    tipo: "boolean",
    valor_adicional_pct: 0,
    valor_adicional_fixo: 150,
    ativo: true,
    ordem: 14,
  },
  {
    id: "crit-ecommerce",
    nome: "Operação de E-commerce / Marketplaces",
    descricao: "Volume elevado de notas de venda B2C interestaduais",
    grupo: "Tecnologia",
    tipo: "faixa",
    valor_adicional_pct: 15,
    valor_adicional_fixo: 250,
    ativo: true,
    ordem: 15,
  },

  // Grupo Societário & Consultoria
  {
    id: "crit-filiais",
    nome: "Filiais / Múltiplos Estabelecimentos",
    descricao: "Apuração centralizada e obrigações por CNPJ filial",
    grupo: "Societário",
    tipo: "quantidade",
    valor_adicional_pct: 0,
    valor_adicional_fixo: 200,
    ativo: true,
    ordem: 16,
  },
  {
    id: "crit-reunioes-mensais",
    nome: "Reuniões Mensais de Alinhamento e DRE",
    descricao:
      "Apresentação consultiva de indicadores gerenciais com a diretoria",
    grupo: "Societário",
    tipo: "boolean",
    valor_adicional_pct: 10,
    valor_adicional_fixo: 400,
    ativo: true,
    ordem: 17,
  },
];

export const DEFAULT_PLANOS: PlanoConfig[] = [
  {
    id: "plano-basico",
    nome: "Básico (Conformidade)",
    descricao:
      "Cumprimento de todas as obrigações acessórias, fiscais e folha de pagamento padrão.",
    multiplicador: 1.0,
    faturamento_min: 0,
    faturamento_max: 50000,
    cor: "#64748b",
    destaque: false,
    ativo: true,
    ordem: 1,
  },
  {
    id: "plano-essencial",
    nome: "Essencial (Gestão Ativa)",
    descricao:
      "Conformidade fiscal completa + relatórios gerenciais trimestrais e integração com ERP.",
    multiplicador: 1.25,
    faturamento_min: 50000,
    faturamento_max: 200000,
    cor: "#3b82f6",
    destaque: true,
    ativo: true,
    ordem: 2,
  },
  {
    id: "plano-estrategico",
    nome: "Estratégico (Consultivo)",
    descricao:
      "BPO financeiro opcional, planejamento tributário contínuo, DRE mensal e reunião executiva.",
    multiplicador: 1.5,
    faturamento_min: 200000,
    faturamento_max: null,
    cor: "#8b5cf6",
    destaque: false,
    ativo: true,
    ordem: 3,
  },
];
